<template>
    <Section
        :id="id"
        :bg="bg"
        :color="color"
        :hero="hero"
        :wave="hero"
        :reveal="true"
    >
        <slot></slot>
    </Section>
</template>

<script>
import Section from 'templates/layout/Section';

export default {
    name: 'grid-section',
    components: {
        Section,
    },
    props: {
        id: {
            type: String,
        },
        hero: {
            type: Boolean,
        },
        color: {
            type: Object,
        },
        bg: {
            type: Object,
        },
    },
};
</script>
